import { LitElement, html } from "lit-element";
import { connect } from "pwa-helpers/connect-mixin.js";
import { store } from "../inspx-store.js";
import { sync } from "../styles/icons.js";
import { fetchCompletedInspections } from "../actions/completed-inspections.js";
import { SharedStyles } from "../styles/shared-styles.js";
import { CardStyles } from "../styles/card-styles.js";
import { InspectionListStyles } from "../styles/inspection-list-styles.js";
import "../elements/inspx-ajax-image.js";
import { navigate } from "../actions/app.js";

class InspxCompletedInspections extends connect(store)(LitElement) {
	render() {
		return html`
            ${SharedStyles}
            ${CardStyles}
            ${InspectionListStyles}

            <style>
                .title {
                    display: flex;
                }
                .sync {
                    width: 24px;
                    height: 24px;                   
                    fill: #697384;    
                    display: inline-block;                
                    -webkit-animation:spin 4s linear infinite;
                    -moz-animation:spin 4s linear infinite;
                    animation:spin 4s linear infinite;
                }

                @-moz-keyframes spin { 100% { -moz-transform: rotate(-360deg); } }
                @-webkit-keyframes spin { 100% { -webkit-transform: rotate(-360deg); } }
                @keyframes spin { 100% { -webkit-transform: rotate(-360deg); transform:rotate(-360deg); } }
            </style>

            <div class="list">
                ${this.items.map(c => this._renderCustomer(c))}
            </div>`;
	}

	_renderCustomer(c) {
		return html`
            <div class="topGroup">${c.customerName} </div>
            ${c.projects.map(p => this._renderProject(p))}`;
	}

	_renderProject(p) {
		return html`
            <div class="nestedGroup">${p.projectName}</div>
            ${p.inspections.map(i => this._renderInspection(i))}`;
	}

	_renderInspection(i) {
		let syncIcon = "";
		if(i.status == "done") {
			syncIcon = html`<div class="sync">${sync}</div>`;
		}

		return html`
            <div class="card" @click="${() => this.goToInspection(i)}">
                <div class="h-image">
                    <inspx-ajax-image .src="${this.getImageUrl(i._key)}"></inspx-ajax-image>              
                </div>
                <div class="f">
                    <div class="title">
                        ${syncIcon}${i.name}
                    </div>
                    <div class="info">
                        <span>
                            ${i.type.name}
                        </span>
                        <span>
                            ${i.date}
                        </span>
                    </div>
                </div>
            </div>`;
	}

	getImageUrl(key) {
		return key
			? window.INSP.config.apiUrl + "/api/inspection/getCover/" + key
			: undefined;
	}

	static get properties() {
		return { items: Array };
	}

	constructor() {
		super();
		store.dispatch(fetchCompletedInspections());
		this.items = [];
	}

	goToInspection(i) {
		let firstTab = i.type.firstTab || '';
		store.dispatch(navigate(`/remote-inspection/${i._key}/${firstTab}`));
	}

	stateChanged(state) {
		if (state.completedInspections.reload === true)
			store.dispatch(fetchCompletedInspections());

		this.items = state.completedInspections.items;
	}
}

window.customElements.define(
	"inspx-completed-inspections",
	InspxCompletedInspections
);
